import { createTheme } from "@mui/material/styles";
import { tokens } from "./tokens";

const colorScheme = (scheme) => ({
  palette: {
    primary: { main: scheme.primary, contrastText: scheme["primary-contrast"] },
    background: { default: scheme.bg, paper: scheme.surface },
    text: { primary: scheme.text, secondary: scheme.muted },
    divider: scheme.border,
  },
});

export const STORAGE_KEY = "dp-theme-mode";

export const theme = createTheme({
  cssVariables: { colorSchemeSelector: "data-theme" },
  colorSchemes: {
    dark: colorScheme(tokens.dark),
    light: colorScheme(tokens.light),
  },
  typography: {
    fontFamily: "Montserrat, sans-serif",
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--dp-border-strong)" },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "var(--dp-muted)" },
        },
      },
    },
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          "& .MuiPickersOutlinedInput-notchedOutline": { borderColor: "var(--dp-border-strong)" },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 16, border: "1px solid var(--dp-border)" },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "--DataGrid-t-color-background-base": "var(--dp-surface)",
          "--DataGrid-t-header-background-base": "var(--dp-surface-raised)",
          "--DataGrid-t-color-border-base": "var(--dp-border)",
          "--DataGrid-t-radius-base": "16px",
          "--DataGrid-rowBorderColor": "var(--dp-border)",
          border: "1px solid var(--dp-border)",
          borderRadius: 16,
          overflow: "hidden",
          fontSize: 13,
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: 11,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            color: "var(--dp-muted)",
          },
          "& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: "var(--dp-row-selected)",
          },
          "& .MuiDataGrid-footerContainer": {
            color: "var(--dp-muted)",
          },
        },
      },
    },
  },
});
